module.exports = __webpack_public_path__ + "static/media/syn-olltaekin-1920x1080.0ab22dae.jpg";